import { Route, Switch } from 'react-router';

import { replaceParams } from '@dreryk/drerykweb-main-frontend';
import { NotFoundPanel } from '@dreryk/react-components';

import { StatisticsPreviewPanel } from './statistics/preview/StatisticsPreviewPanel';
import { StatisticsPanel } from './statistics/StatisticsPanel';

const STATISTICS_PATH = '/statystyki';
const STATISTICS_PREVIEW_PATH = `${STATISTICS_PATH}/:statisticsId/podglad`;

export const getStatisticsPath = (): string => STATISTICS_PATH;
export const getStatisticsPreviewPath = (statisticsId: number): string =>
   replaceParams(STATISTICS_PREVIEW_PATH, {
      statisticsId: statisticsId.toString(),
   });

export const StatisticsRouter = (): JSX.Element => {
   return (
      <Switch>
         <Route exact path={STATISTICS_PATH}>
            <StatisticsPanel />
         </Route>
         <Route path={STATISTICS_PREVIEW_PATH}>
            <StatisticsPreviewPanel />
         </Route>
         <Route>
            <NotFoundPanel />
         </Route>
      </Switch>
   );
};
